import React from 'react'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl } from '../AssetHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string
  defaultColor?: boolean
  color?: string
}

const KTSVG: React.FC<Props> = ({
  className = '',
  path,
  defaultColor,
  svgClassName = 'mh-100px',
  color,
}) => {
  const colorStyle = color ? { color } : undefined
  if (defaultColor)
    return <SVG src={toAbsoluteUrl(path)} className={className} style={colorStyle} />
  return (
    <span className={`svg-icon ${className}`} style={colorStyle}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export { KTSVG }
